import { useMediaQuery } from '@mui/material';
import React from 'react';
import { Box, Modal as ECModal, Spacer } from '@eatclubcode/ec-component-library';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import ArrowLong from '../../../assets/icons/arrow_long.svg';
import { PrimaryButton } from '../../../components/button/PrimaryButton';
import { trackDetailedEvent } from '../../../utils/analytics';
import { getQBRTimePeriod } from '../businessReviewHelpers';
import useStyles, { buttonStyle, modalInputStyle, modalStyle } from './BusinessReviewModalStyles';

const BusinessReviewModal = ({ isOpen, onClose, onConfirm }) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const breakpointMdDown = useMediaQuery(theme.breakpoints.down('md'));
  const timePeriod = getQBRTimePeriod();

  return (
    <ECModal
      fullWidth
      isOpen={isOpen}
      onClose={onClose}
      showCloseText={false}
      heading='Quarterly business review'
      style={modalStyle}
      inputStyle={modalInputStyle}
      hideFooter
    >
      <Spacer className={classes.businessReviewModal}>
        <Spacer className={classes.left} direction='vertical'>
          <Spacer className={classes.content} direction='vertical'>
            <Box className={classes.title}>Quarterly Business Review</Box>
            <Box className={classes.date}>{timePeriod}</Box>
          </Spacer>

          <Spacer className={classes.bottom} direction='vertical'>
            <Box className={classes.description}>
              A look back at the wins you’ve made this quarter with dynamic pricing and the insights
              to drive even stronger performance ahead.
            </Box>
            <PrimaryButton
              style={buttonStyle}
              onClick={() => {
                trackDetailedEvent('Get Started Clicked');
                history.push('/business-review');
                onConfirm();
              }}
            >
              <Box className={classes.buttonContent}>
                Get started
                <ArrowLong className={classes.arrow} />
              </Box>
            </PrimaryButton>
          </Spacer>
        </Spacer>
        {!breakpointMdDown && (
          <img
            src='https://eccdn.com.au/partnerportal/img/qbr_landing.svg'
            className={classes.image}
            alt='QBR images'
          />
        )}
      </Spacer>
    </ECModal>
  );
};

export default BusinessReviewModal;
